import { makeStyles } from "@material-ui/core";

const JobHistoryStyle = makeStyles({
  jobHistory: {
    "& .MuiPaper-elevation1": {
      boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.14)"
    },
    "& .MuiAccordionDetails-root": {
      backgroundColor: "#f9fafb",
      flexDirection: "column",
      gap: "20px",
    },
    "& .item-handoff": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "16px",
      "& .item-handoff-title": {
        fontWeight: "bold",
        marginBottom: "10px",
        "& .MuiSvgIcon-root": {
          transform: "translateY(30%)",
          color: "#4d617a"
        }
      },
      "& .item-handoff-content": {
        color: "#4d617a"
      },
      "& .item-handoff-status": {
        borderRadius: "15px",
        fontSize: "14px",
        fontWeight: "500"
      }
    },
    "& .prompt-cancel-status": {
      background: "#E5E7EB",
      padding: "10px",
      borderRadius: "5px"
    },
    "& .item-handoff-details": {
      display: "flex",
      justifyContent: "flex-start",
      width: "100%",
      gap: "20px",
      fontSize: "14px",
      flexWrap: "wrap",
      "& .item-handoff-option": {
        flex: 1,
      },
      "& .item-handoff-vehicle-option": {
        flex: 1,
      },
      "& .item-handoff-details-title": {
        fontWeight: "bold",
        color: "#888888"
      }
    },
    "& .item-handoff-manifest": {
      width: "100%",
      fontSize: "14px",
      "& .item-handoff-details-title": {
        fontWeight: "bold",
        color: "#888888"
      }
    },
    "& .backgroundAccepted": {
      backgroundColor: "#dcfce7",
      color: "#296A34",
      padding: "5px 12px"
    },
    "& .backgroundPending": {
      backgroundColor: "#fef9c3",
      color: "#954d0e",
      padding: "5px 12px"
    },
    "& .backgroundRejected": {
      backgroundColor: "#fee2e2",
      color: "#9C1B1B",
      padding: "5px 12px"
    },
    "& .backgroundRemoved": {
      backgroundColor: "#f3f4f6",
      color: "#1F2937",
      padding: "5px 12px"
    }
  }
});

export { JobHistoryStyle };
